<template>
    <div class="user-case-main">
        <div class="user-case-body">
            <h2>全部用户案例</h2>
            <div class="categories">
                <span v-for="category in categories" :key="category.id"
                    :class="{ active: activeCategory === category.name }" @click="setCategory(category.name)">{{
                        category.name }}</span>
            </div>
            <div class="case-list">
                <div class="case-item" v-for="caseItem in cases" :key="caseItem.id">

                    <img :src="(caseItem.img ? caseItem.img.split(',')[0] : '')" alt="案例图片" class="case-image" />
                    <div class="case-content">
                        <h3>{{ getTitleWithoutBrackets(caseItem.title) }}</h3>
                        <p class="txtSmall">用户痛点 | {{ caseItem.refine }}</p>
                        <p class="effect-ellipsis">{{ caseItem.effect }}</p>
                        <button @click="viewDetails(caseItem.id)" style="margin-top: 108PX;">查看详情</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

import { caseListByType } from "@/api/dataManeger.js";
import { IMG_BASE_URL } from "@/utils/index.js"; // 新增导入
export default {
    name: 'UserCaseMain',
    data() {
        return {
            activeCategory: '公共安全',
            activeCategoryId: 3, // 新增：默认选中“公共安全”的id
            cases: [],
            categories: [
                { id: 1, name: '低空经济' },
                { id: 2, name: '电网' },
                { id: 3, name: '新能源' },
                { id: 4, name: '能源' },
                { id: 5, name: '轨道交通' },
                { id: 6, name: '其他' }
            ], // 分类数组增加id属性
        };
    },
    computed: {
        filteredCases() {
            return this.cases.filter((caseItem) => caseItem.category === this.activeCategory);
        },
        // 添加IMG_BASE_URL到组件作用域
        IMG_BASE_URL() {

            return IMG_BASE_URL;
        }
    },
    watch: {
        // 监听 detData 变化，优先更新 imgList
        // detData: {
        //     deep: true,
        //     immediate: true,
        //     handler(newVal) {
        //         if (newVal && Object.keys(newVal).length > 0) {
        //             this.imgList = [
        //                 {
        //                     src: newVal.src || '',
        //                     line1: newVal.line1 || '',
        //                     line2: newVal.line2 || '',
        //                 },
        //             ];
        //         } else {
        //             this.updateImgList();
        //         }
        //     },
        // },
        // 监听 URL 的变化
        '$route.fullPath': {
            immediate: true,
            handler() {
                const urlParams = new URLSearchParams(window.location.search);
                const navUserCaseType = urlParams.get('navUserCaseType');
                console.log('navUserCaseType from URL:', navUserCaseType);
                if (navUserCaseType) {
                    const category = this.categories.find(c => c.id === Number(navUserCaseType));
                    if (category) {
                        this.activeCategory = category.name;
                        this.activeCategoryId = category.id;
                        this.setCategory(category.name);
                    }
                }
                
                // // 如果当前路由是 all_user_cases，则向上滚动页面 30%
                // if (this.$route.path === '/all_user_cases') {
                //     const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
                //     const delta = Math.floor(scrollHeight * 0.3); // 要向上滚动的像素值（页面高度的30%）
                //     const targetY = Math.max(0, window.scrollY - delta);
                //     window.scrollTo({ top: targetY, behavior: 'smooth' });
                // }
            },
        },
    },
    methods: {
        setCategory(categoryName) {
            const category = this.categories.find(c => c.name === categoryName);
            this.activeCategory = categoryName;
            this.activeCategoryId = category ? category.id : null;
            this.getCases();
            // 记录当前滚动位置
            const scrollY = window.scrollY;

            const newQuery = { source: 'all_user_cases', navUserCaseType: category ? String(category.id) : undefined };

            // 如果当前路由已经是目标路由并且 query 相同，避免重复导航（会导致控制台报错），直接替换地址栏并恢复滚动
            if (this.$route.path === '/all_user_cases' && String(this.$route.query.navUserCaseType) === String(newQuery.navUserCaseType)) {
                // 只替换地址（不会触发路由导航），避免 NavigationDuplicated 错误
                const resolved = this.$router.resolve({ path: '/all_user_cases', query: newQuery }).href;
                window.history.replaceState(null, '', resolved);
                window.scrollTo(0, 600);
                return;
            }

            // 否则使用 replace 导航，并捕获可能的重复导航错误，导航完成后恢复滚动位置
            this.$router.replace({ path: '/all_user_cases', query: newQuery })
                .then(() => {
                    // 等待视图更新后恢复位置
                    this.$nextTick(() => window.scrollTo(0, scrollY));
                })
                .catch(() => {
                    // 忽略重复导航的错误，并恢复滚动
                    window.scrollTo(0, 600);
                });
        },
        viewDetails(id) {
            const caseItem = this.cases.find((item) => item.id === id);
            if (caseItem) {
                this.$router.push({ path: '/user_case_detail', query: { source: caseItem.route, id: id, userCaseType: this.activeCategoryId } });
            }
        },
        getCases() {
            caseListByType({ type: this.activeCategoryId }).then((res) => {
                if (res) {
                    this.cases = res.result.filter(item => item.img); // 只保留img不为空的
                }
            })
        },
        getTitleWithoutBrackets(title) {
            // 去除括号及其内容（支持中文和英文括号）
            return title ? title.replace(/[\(\（][^\)\）]*[\)\）]/g, '').trim() : '';
        },
    },
    mounted() {

        this.getCases(); // 页面加载时调用接口
    },
};
</script>

<style lang="scss" scoped>
.user-case-main {
    padding: 0PX;
    padding-bottom: 80PX;

    .user-case-body {
        width: 1200px;
        margin: 0 auto;
    }

    h2 {
        font-size: 1.8rem;
        text-align: center;
        font-family: PingFang SC;
        font-size: 32PX;
        font-weight: bold;
        line-height: normal;
        letter-spacing: normal;
        color: #1E242A;
        margin: 80PX 0 50PX;
    }

    .categories {
        display: flex;
        justify-content: center;
        gap: 40PX; // 调整间距以匹配图片
        margin-bottom: 40PX;

        span {
            cursor: pointer;
            font-size: 18PX; // 调整字体大小
            color: #1e242acc; // 默认字体颜色
            position: relative;

            &:hover {
                font-weight: bold;
            }

            &.active {
                color: #0f6bf6; // 激活状态字体颜色
                font-weight: bold;

                &::after {
                    content: '';
                    position: absolute;
                    bottom: -5PX;
                    left: 50%;
                    transform: translateX(-50%);
                    width: 100%;
                    height: 2PX;
                    background-color: #0f6bf6; // 下划线颜色
                }
            }
        }
    }

    .case-list {
        display: flex;
        flex-direction: column;
        gap: 20PX;

        .case-item {
            width: 100%; // 设置宽度为父元素的宽度
            vertical-align: top;
            // border: 1PX solid #ddd;
            border-radius: 8PX;
            // padding: 15PX;
            background-color: #fff;

            .case-image {
                display: inline-block;
                width: 650PX; // 宽度设置为100%以适应flex布局
                height: 380PX; // 高度最大380PX，超出裁剪
                object-fit: cover; // 保证宽度为准，高度自适应，超出部分裁剪，不压缩画质
                border-radius: 8PX;
                float: left;

            }

            .case-content {
                display: inline-block;
                float: left;
                width: 540PX;
                padding: 40PX;
                padding-right: 0PX;
                display: flex;
                flex-direction: column;
                gap: 16PX;

                h3 {
                    font-size: 20PX; // 标题字体大小
                    font-weight: bold; // 标题加粗
                    color: #1e242a; // 标题颜色
                    margin: 0; // 去除默认外边距
                    white-space: nowrap; // 禁止换行
                    overflow: hidden; // 超出隐藏
                    text-overflow: ellipsis; // 超出部分显示省略号
                }

                .txtSmall {
                    font-family: PingFang SC;
                    font-size: 14PX;
                    font-weight: normal;
                    line-height: normal;
                    letter-spacing: normal;
                    color: #1E242A;
                    opacity: 0.4;
                    white-space: nowrap; // 新增：禁止换行
                    overflow: hidden; // 新增：超出隐藏
                    text-overflow: ellipsis; // 新增：显示省略号
                }

                p {
                    font-size: 16PX; // 描述字体大小
                    color: #4a4a4a; // 描述文字颜色
                    line-height: 1.8; // 增加行高
                    margin: 0; // 去除默认外边距
                }

                .effect-ellipsis {
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: normal;
                }

                button {
                    align-self: flex-start; // 按钮靠左对齐
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 8PX 16PX; // 按钮内边距
                    font-size: 14PX; // 按钮字体大小
                     // 按钮字体权重
                    color: #1e242a; // 按钮文字颜色
                    background-color: transparent; // 按钮背景透明
                    border: 1PX solid #1e242a; // 按钮边框
                    border-radius: 4PX; // 按钮圆角
                    cursor: pointer;
                    transition: all 0.3s;

                    // 新增：只显示两行，超出部分省略号
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    white-space: normal;

                    &:hover {
                        background-color: #1e242a; // 悬停背景色
                        color: #fff; // 悬停文字颜色
                    }

                    &::after {
                        content: '>'; // 添加箭头
                        margin-left: 8PX; // 调整箭头与文字间距
                        font-size: 16PX;
                    }
                }
            }
        }
    }
}

::v-deep .el-tabs__item {
  /* 修改为您想要的文字大小 */
  font-weight: normal !important;
}
</style>
